/** Convert a click position to map pin coordinates (0–100%) relative to the rendered image. */
export function percentCoordsFromClick(
  image: HTMLImageElement,
  clientX: number,
  clientY: number,
): { x: number; y: number } {
  const rect = image.getBoundingClientRect();
  const x = ((clientX - rect.left) / rect.width) * 100;
  const y = ((clientY - rect.top) / rect.height) * 100;

  return {
    x: Math.min(100, Math.max(0, Math.round(x * 100) / 100)),
    y: Math.min(100, Math.max(0, Math.round(y * 100) / 100)),
  };
}
